import {
    createBrowserRouter,
} from "react-router-dom";
import BecomeInstructor from './Pages/BecomeInstructor/BecomeInstructor';
import Checkout from './Pages/Checkout/Checkout';
import CourseDetail from './Pages/CourseDetail/CourseDetail';
import Instructor from './Pages/Instructor/Instructor';
import Landing from './Pages/Landing/Landing';
import Login from './Pages/Login/Login';
import Profile from './Pages/Profile/Profile';
import Signup from './Pages/Signup/Signup';
import Watch from './Pages/Watch/Watch';
import Root from "./Root";
import Category from "./Pages/Category/Category";
import VerifyPayment from "./Pages/VerifyPayment";
import Terms from "./Pages/Terms";
import Privacy from "./Pages/Privacy";

const router = createBrowserRouter([
    {
      path: "/",
      element: <Root />,
      children: [
        {
            path: "/",
            element: <Landing />
        },
        {
            path: "/login",
            element: <Login />
        },
        {
            path: "/signup",
            element: <Signup />
        },
        {
            path: "/profile",
            element: <Profile />
        },
        {
            path: "/course/:id",
            element: <CourseDetail />
        },
        {
            path: "/learn/:id",
            element: <Watch />
        },
        {
            path: "/checkout/:id",
            element: <Checkout />
        },
        {
            path: "/category/:maincat/:subcat?",
            element: <Category />
        },
        {
            path: "/verify-payment/:id",
            element: <VerifyPayment />
        },
        {
            path: "/instructor/:id",
            element: <Instructor />
        },
        {
            path: "/terms",
            element: <Terms />
        },
        {
            path: "/privacy",
            element: <Privacy />
        }
      ]
    },
]);

export default router